import { useRefreshPermissions } from '@backoffice-frontend/user-management-ui'
import { ActionItem } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'

export const RefreshPermissionsButton = () => {
  const refreshPermissions = useRefreshPermissions()
  const { t } = useTranslation()

  return (
    <ActionItem
      label={t('authenticatedAppView_refreshPermissions_button')}
      onClick={() => refreshPermissions()}
    />
  )
}
